import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
export const getCurrentLocation = createAsyncThunk(
    'home/getLocation',
    async (_, { rejectWithValue }) => {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                    
                        resolve(position.coords);  
                    },
                    (error) => {
                        rejectWithValue("Failed to get location"); 
                    }
                );
            } else {
                rejectWithValue("Geolocation is not supported by this browser.");
            }
        });
    }
);


// Create the slice
const locationSlice = createSlice({
    name: "location",
    initialState: {
        error: null,
        locationError: null,  // Store location error message
        status: 'idle',
        location: null,  // Store geolocation data
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCurrentLocation.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getCurrentLocation.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.location = action.payload;  // Store the geolocation coordinates
            })
            .addCase(getCurrentLocation.rejected, (state, action) => {
                state.status = 'failed';
                state.locationError = action.payload;  // Store the location error
            });
    },
});

export default locationSlice.reducer;




